import { useContext, useEffect, useRef, useState } from "react";
import axios from "../API/axios";
import AuthContext from "../Context/AuthProvider";
import { changeAppointment, getAvailableSlots } from "../API/AppointmentsApi";
import {
  getPrimaryClinicalServices,
} from "../API/FacilitySettingsApi";
import {
  convertUTCToTimeZone,
  getDatesArray,
} from "../Utility/DateTimeUtility";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid2,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import SlotSelector from "./SlotSelector";
import { useSnackbar } from "../Utility/UserMessageContext";

function ChangeVisitDialog({
  reset,
  visit,
  refreshAppointments,
  openState,
  setOpenState,
}) {
  const {showSnackbar} = useSnackbar();
  const [availablePhysicians, setAvailablePhysicians] = useState();
  const USER_SEARCH_URL = "/api/account/search";
  const [availableSlots, setAvailableSlots] = useState();
  const { auth } = useContext(AuthContext);
  const [patientNotes, setPatientNotes] = useState(visit?.notes);
  const [availableServices, setAvailableServices] = useState();
  const [successMessage, setSuccessMessage] = useState();
  const [selectedTimeSlot, setSelectedTimeSlot] = useState();
  const [selectedServiceId, setSelectedServiceId] = useState();
  const [selectedService, setSelectedService] = useState();
  const [selectedPhysicianId, setSelectedPhysicianId] = useState();
  const [selectedPhysician, setSelectedPhysician] = useState();
  const noOfDaysToShowSlots = 7;
  const [dateRange, setDateRange] = useState(
    getDatesArray(new Date(), noOfDaysToShowSlots)
  );
  const [addingAppointment, setAddingAppointment] = useState(false);
  const [isWalkIn, setIsWalkIn] = useState(visit?.isWalkIn);

  useEffect(() => {
    const getPhysicians = async () => {
      await axios
        .post(
          USER_SEARCH_URL,
          {
            facilityId: auth.selectedFacility.id,
            roles: ["Physician"],
          },
          {
            headers: {
              Authorization: "Bearer " + auth.authToken,
              Accept: "application/json, text/plain, */*",
              "Content-Type": "application/json",
            },
          }
        )
        .then(function (response) {
          setAvailablePhysicians(response?.data);
          setSelectedPhysicianId(visit?.physicianId);
          setSelectedPhysician(
            response?.data.find((p) => p.id === visit?.physicianId)
          );
        })
        .catch(function (error) {
          showSnackbar(error?.response?.data, "error");
        });
    };

    const setClinicalServices = async () => {
      var result = await getPrimaryClinicalServices(auth);
        if (result.isSuccess) {
        console.log(result?.data);
        setAvailableServices(result?.data);
        setSelectedServiceId(visit?.primaryClinicalServiceId);
        setSelectedService(
          result?.data.find((s) => s.id === visit?.primaryClinicalServiceId)
        );
      } else {
        showSnackbar(result?.data, "error");
      }
    };
    setClinicalServices();
    getPhysicians();
  }, [auth, visit]);

  const showSlotsForDefaultDateRange = () => {
    setDateRange(getDatesArray(new Date(), noOfDaysToShowSlots));
  };

  const saveAppointment = async (e) => {
    // setAddingAppointment(true);
    // e.preventDefault();
    // const result = await changeAppointment(
    //   auth,
    //   visit?.id,
    //   selectedTimeSlot,
    //   selectedPhysicianId,
    //   patientNotes,
    //   selectedServiceId,
    //   isWalkIn,
    // );
    // if (result.isSuccess) {
    //   setOpenState(false);
    //   refreshAppointments();
    //   showSnackbar("Visit updated successfully.", "success");
    // } else {
    //   showSnackbar(result?.data, "error");
    // }
    // setAddingAppointment(false);
  };

  const onCancel = () => {
    reset();
  };


  return (
    <>
      <Dialog open={openState} maxWidth="md"
        fullWidth>
        <DialogTitle>
          Edit Visit Details for {visit?.patientPrefix}{" "}
          {visit?.patientFirstName} {visit?.patientLastName}
        </DialogTitle>
        <DialogContent dividers>
          <Grid2 container size={12} spacing={2}>
            <Grid2 container size={6}>
              <Grid2 item size={12}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Primary Service
                  </InputLabel>
                  <Select
                    label="Primary Service"
                    value={selectedServiceId}
                    disabled={addingAppointment}
                    onChange={(e) => {
                      setSelectedServiceId(e.target.value);
                      setSelectedService(
                        availableServices.find((s) => s.id === e.target.value)
                      );
                      showSlotsForDefaultDateRange();
                    }}
                  >
                    {availableServices &&
                      availableServices?.map((s) => (
                        <MenuItem value={s.id}>
                          {s.name}, Fees Rs. {s.fees}, Duration{" "}
                          {s.durationInMins} Mins
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid2>
              <Grid2 container size={12}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Physician
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedPhysicianId}
                    label="Physician"
                    disabled={addingAppointment}
                    onChange={(e) => {
                      setSelectedPhysicianId(e.target.value);
                      setSelectedPhysician(
                        availablePhysicians.find((p) => p.id === e.target.value)
                      );
                      showSlotsForDefaultDateRange();
                    }}
                  >
                    {availablePhysicians &&
                      availablePhysicians?.map((p) => (
                        <MenuItem value={p.id}>
                          {p.salutation} {p.firstName} {p.lastName}, {p.suffix}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid2>
              <Grid2 container size={12}>
                <TextField
                  fullWidth
                  label="Notes"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  value={patientNotes}
                  multiline
                  minRows={3}
                  maxRows={3}
                  disabled={addingAppointment}
                  onChange={(e) => {
                    setPatientNotes(e.target.value);
                  }}
                ></TextField>
              </Grid2>
              <Grid2 container size={12}>
                <Typography>Previously Selected Time Slot:</Typography>
                <Typography>
                {convertUTCToTimeZone(visit?.visitDateTime, auth?.selectedFacility?.timeZone).format("DD-MMM-YYYY hh:mm A")}
                </Typography>
              </Grid2>
            </Grid2>
            <Grid2 container size={6}>
                <SlotSelector key="editVisit" isWalkInAllowed={selectedService?.allowedBookingType !== "PreBooking"} isWalkIn={isWalkIn} setIsWalkIn={setIsWalkIn} selectedService={selectedService} selectedPhysicianId={selectedPhysicianId} selectedServiceId={selectedServiceId} selectedTimeSlot={selectedTimeSlot} setSelectedTimeSlot={setSelectedTimeSlot} dateRange={dateRange} setDateRange={setDateRange}></SlotSelector>
            </Grid2>
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenState(false)}
            variant="outlined"
            color="inherit"
          >
            Close
          </Button>
          <Button
            onClick={saveAppointment}
            disabled={addingAppointment || !selectedTimeSlot}
            variant="contained"
            color="secondary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default ChangeVisitDialog;
